import { useNavigate } from "react-router-dom";
import FormTabs from "./FormTabs";
import PageTitleWithBack from "@components/common/PageTitleWithBack";

const FormHeader = ({
  title,
  isSticky,
  tabs,
  activeTabIndex,
  setActiveTabIndex,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`transition-all duration-500 ${
        isSticky ? "sticky top-[4rem] z-40 py-5 bg-white" : ""
      }`}
    >
      <PageTitleWithBack
          title= {title}
          onBack={() => navigate(-1)}
        />
      <FormTabs
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
      />
    </div>
  );
};

export default FormHeader;
